import React from 'react'
import ReactDOM from 'react-dom'
import { BrandLogo } from '../BrandLogo/BrandLogo'
import { NavMenu } from '../NavMenu/NavMenu'
import styles from './NavMobile.module.scss'
import Hamburger from '/public/assets/svg/hamburger.svg'
import CloseThin from '/public/assets/svg/close-thin.svg'
import cx from 'classnames'
import CtaButton from '../CtaButton/CtaButton'
import BackgroundGradientBlur from '../BackgroundGradientBlur/BackgroundGradientBlur'
import { getPortalRoot } from 'utils'
import { useNavigation } from '../../NavigationContext'

export const NavMobile = () => {
  const { brandLogo, ctaButton, navDrawerIsOpen, toggleNavDrawer, navigationMenuItems } = useNavigation()

  const hasNavMenuItems = navigationMenuItems.length !== 0
  const portalRoot = getPortalRoot()

  return (
    <div className={styles['navbar-mobile']}>
      {hasNavMenuItems && (
        <button
          className={cx([styles['navbar-drawer-toggler'], navDrawerIsOpen && styles['navbar-drawer-toggler--is-open']])}
          onClick={toggleNavDrawer}
        >
          {navDrawerIsOpen ? <CloseThin /> : <Hamburger />}
        </button>
      )}
      <BrandLogo url={brandLogo?.url} />

      <div
        className={cx([styles['navbar-mobile__drawer'], navDrawerIsOpen && styles['navbar-mobile__drawer--is-open']])}
      >
        <div className={styles['drawer-scroller']}>
          <NavMenu />
        </div>
      </div>

      {/* createPortal avoids css conflicts where blur() property can't be set on on parent and child. */}
      {navDrawerIsOpen &&
        portalRoot &&
        ReactDOM.createPortal(
          <BackgroundGradientBlur onClickHandler={toggleNavDrawer} isFixedPosition={true} />,
          portalRoot
        )}

      <CtaButton {...ctaButton} />
    </div>
  )
}
